class RouteSummaryOrdersRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'RouteSummaryOrders';

        super(entityName);

        var options = Monet.Grid.Utils.paginationOptions;
        if (!App.Forms.RouteSummaryOrders) {
            App.Forms.RouteSummaryOrders = {
                layout: {},
                dataMapper: null,
                pagination: {
                    first: options.FIRST,
                    max: options.MAX_RESULT,
                    blocked: false,
                    canIncrement: true
                },
                stop: null,
                columnToOrders: []
            };
        }

        if (!App.Objects.RouteSummaryOrders) {
            App.Objects.RouteSummaryOrders = this;
        }
    }

    needSetPrefix = (attr) => {
        //essa bendita chamada será para StopView.. sim, mesmo sendo de Order.
        // Ou seja, em StopView, o order está em stop.orders
        const STOP = 'stop.';
        const ROUTEVIEW = 'routeView.';
        const startsWithStop = attr.substring(0, STOP.length) === STOP;
        const startsWithRouteView = attr.substring(0, ROUTEVIEW.length) === ROUTEVIEW;

        return !startsWithStop && !startsWithRouteView;
    }

    getFieldsToGridLayout = (callback) => {
        var error = null,
            ajax = null,
            url = 'form/RouteMonitorOrder/index';

        try {
            ajax = new Monet.Ajax();
            ajax.url = url;
            ajax.success = (data) => {
                if (data) {
                    App.Forms.RouteSummaryOrders.layout['index'] = data;
                }
                if (callback) {
                    callback();
                }
            };

            ajax.error = (response) => {
                Monet.Configurations.errorNotification(null, response);
            };

            ajax.send();
        } catch (e) {
            error = new Monet.Exception.ReturnError(this,
                'Error on get grid layout on route monitoring route');
            error.console();
        }
    }

    updateGrid = (filter, callback, appendCollection, action) => {
        var error = null,
            that = this,
            _filter = {},
            columns = [],
            processProjection = '',
            orders = null,
            pagination = {},
            projectionBuilder = null,
            addPaginationGrid = true;

        try {
            if (filter) {
                _filter = filter;
            }

            columns = App.Forms.RouteSummaryOrders.table.getColumns();
            filter = App.Forms.RouteSummaryOrders.filterBuilder;

            if (action === 'update') {
                var firstResult = 0;
                var updater;
                var page;
                var pages;
                var options;
                options = Monet.Grid.Utils.paginationOptions;

                updater = App.Forms.RouteSummaryOrders.controlUpdater;
                page = updater.getPageByScrollPosition();

                pages = updater.getPages();


                if (page !== 0) {
                    firstResult = pages[page].firstResult;
                }
                pagination.first = firstResult;
                pagination.max = options.MAX_RESULT;

            } else {
                pagination = App.Forms.RouteSummaryOrders.pagination;
            }

            orders = new App.Collections.Orders();
            projectionBuilder = new Monet.Builder.Projection();

            projectionBuilder.setLayout(JSON.parse(JSON.stringify(App.Forms.RouteSummaryOrders.layout.index)));
            projectionBuilder.parseLayout();
            projectionBuilder.projection.fields = projectionBuilder.projection.fields.map(function (field) {
                if (this.needSetPrefix(field.name)) {
                    field.name = "stop.orders." + field.name;
                }
                return field;
            }.bind(this));

            projectionBuilder.setPagination(pagination);
            processProjection = projectionBuilder.projection.toString();

            if (appendCollection) {
                orders.reset();
            }

            filter.filterButton.showLoading();
            App.Forms.RouteSummaryOrders.pagination.blocked = true;

            orders.filterWithRestrictionsByHaveToMany({
                entityParentToUrl: 'StopView',
                attributeHasMany: 'stop.orders',
                attributesToCopy: ['stop', 'routeView', 'route'],
                filter: _filter,
                criteria: processProjection,
                success: function (result) {

                    if (callback) {
                        callback(that.entityName, columns, result, addPaginationGrid);
                    }

                    filter.loading.hide();
                    filter.filterButton.hideLoading();
                    App.Forms.RouteSummaryOrders.pagination.blocked = false;
                },
                error: () => {
                    filter.filterButton.hideLoading();
                    App.Forms.RouteSummaryOrders.pagination.blocked = false;
                }
            });
        } catch (e) {
            error = new Monet.Exception.ReturnError(this,
                'Error on update route monitoring route', e);
            error.console();
        }
    }

    getFilter = () => {
        var filter = {
            criteriaChain: [],
            sort: []
        },
            columnToOrderLength = 0,
            columnToOrder = App.Forms.RouteSummaryOrders.columnToOrders,
            _filter;

        _filter = App.Forms.RouteSummaryOrders.filterBuilder;

        if (_filter) {
            var criteriaByFilterBuilder = _filter.getCriteriaChain();
            filter.criteriaChain = criteriaByFilterBuilder.criteriaChain;

            for (var index in filter.criteriaChain) {
                var criteria = filter.criteriaChain[index];
                for (var key in criteria) {

                    var chain = criteria[key];

                    for (var i in chain) {
                        let value = chain[i].attr;
                        if (value === 'stop') {
                            value = 'stop.id';
                        } if (this.needSetPrefix(value)) {
                            value = 'stop.orders.' + value;
                        }
                        chain[i].attr = value;
                    }
                }
            }
        }

        if (columnToOrder) {
            columnToOrderLength = columnToOrder.length;
            for (var w = 0; w < columnToOrderLength; w++) {
                var field = columnToOrder[w].field;
                if (this.needSetPrefix(field)) {
                    field = "stop.orders." + field;
                }

                filter.sort.push({
                    attr: field,
                    type: columnToOrder[w].order
                });
            }
        }
        return filter;
    }
}

App.Routers.RouteSummaryOrders = RouteSummaryOrdersRouter;
